import styled from 'styled-components';
import { Box, Flex } from 'atoms';
import { theme } from 'styles/theme';

export const InvoiceContainer = styled.div`
	display: flex;
	align-items: center;
	width: 100%;
	flex-direction: ${(props) => (props.isReceived ? 'column' : 'row')};
`;

export const InvoiceCardContainer = styled.div`
	flex: 1;
	width: 100%;
`;

export const InvoiceBox = styled.div`
	padding: 1rem;
`;

export const BillBackSwipe = styled(Box)`
	display: flex;
	align-items: center;
	padding: 1rem;
	border-radius: 4px;
	border-top-right-radius: 4px;
	border-bottom-right-radius: 4px;
	background: ${theme.colors.YellowOrange};
	font-weight: 600;
	font-size: 12px;
	line-height: 16px;
	color: ${theme.colors.black};
	opacity: ${(props) => props.opacity};
	cursor: pointer;
	text-align: center;
`;

export const ClearSwipe = styled(BillBackSwipe)`
	background: ${theme.colors.GreenBg};
	opacity: ${(props) => props.opacity};
`;

export const DetailContainer = styled(Flex)`
	justify-content: space-between;
	align-items: center;
	padding: 1rem 1rem;
	background: #fff;
	width: 100%;
`;

export const SendBack = styled.div`
	button {
		height: 30px;
		padding: 0 1.3rem;
		border-radius: 2px;
		background-color: ${(props) => (props.BtnGray ? props.theme.colors.LightGray : '#326f02')};
		font-size: 10px;
		font-weight: 400;
		font-family: 'Open Sans';
		color: ${(props) => (props.BtnGray ? props.theme.colors.black : '#fff')};

		&:hover,
		&:active,
		&:focus {
			background-color: ${(props) =>
				props.BtnGray ? props.theme.colors.LightGray : '#326f02'};
			color: ${(props) => (props.BtnGray ? props.theme.colors.black : '#fff')};
		}
	}
`;
